export const EXPERTS_LOADED = 'EXPERTS_LOADED';
export const EXPERT_PROJECT_CLICKED = 'EXPERT_PROJECT_CLICKED';
export const PAGE_CHANGED = 'PAGE_CHANGED';
export const SET_PAGE_COUNT = 'SET_PAGE_COUNT';
export const EXPERTS_LOADING = 'EXPERTS_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const INITIAL_FILTERS_LOADED_FROM_URL =
  'INITIAL_FILTERS_LOADED_FROM_URL';
export const FILTERS_VALIDATION_TOGGLE = 'FILTERS_VALIDATION_TOGGLE';
